export default class Video {
  constructor(element) {
    this.$el = $(element)
    this.init();
  }

  init() {
    const {$el} = this
    const $this = this

    $el.on('click', (e) => {
      e.preventDefault();
      const src = $el.attr('href');
      $this.showVideoPopup(src);
    });

    $('.js-close-popup').on('click', () => {
      $this.hideVideoPopup()
    });
  }

  showVideoPopup(src) {
    $('.video-popup').addClass('show');
    $('body').addClass('menu-opened');
    $('#videoFrame').attr("src", src);
    $('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'playVideo' + '","args":""}', '*');
  }

  hideVideoPopup() {
    $('.video-popup').removeClass('show');
    $('body').removeClass('menu-opened');
    $('iframe')[0].contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    const leg = $('#videoFrame').attr("src");
    $('#videoFrame').attr("src", leg);
  }
}
